// extracted by mini-css-extract-plugin
export default {"wrapper":"EditRoleModal_wrapper__13FTO","formWrapper":"EditRoleModal_formWrapper__w-pM4","field":"EditRoleModal_field__1pQbh","dropdown":"EditRoleModal_dropdown__2xC-X"};